import { CheckCircle2 } from 'lucide-react';
import { IDS } from '@/constants/testIds';
import { useReveal } from '@/hooks/useReveal';

const ABOUT_IMG =
  'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400';

const POINTS = [
  'Registered contractor with Indian Railways & other departments',
  'GSTIN: 06AFZFS3508P1Z1  •  MSME & PAN compliant',
  'In-house team of engineers, supervisors & site managers',
  'Rigorous safety, quality and environmental protocols',
];

export const About = () => {
  const left = useReveal(0);
  const right = useReveal(160);

  return (
    <section id="about" data-testid={IDS.about.section} className="relative py-24 md:py-32 bg-cream">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        {/* Image side */}
        <div ref={left.ref} className={`${left.className} lg:col-span-6 relative`}>
          <div className="relative aspect-[4/5] w-full overflow-hidden">
            <img
              src={ABOUT_IMG}
              alt="Engineer on site"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 ring-1 ring-navy-900/10" />
          </div>
          {/* Gold structural block */}
          <div className="hidden md:block absolute -bottom-8 -right-8 w-40 h-40 bg-gold-400 -z-0" />
          <div className="hidden md:block absolute -top-6 -left-6 w-24 h-24 border border-navy-700 -z-0" />

          {/* Stat card */}
          <div className="absolute bottom-6 left-6 bg-navy-900 text-white px-6 py-5 shadow-xl max-w-[240px]">
            <div className="font-serif text-4xl text-gold-300">Est. 2026</div>
            <div className="text-[10px] tracking-[0.2em] uppercase text-white/60 mt-1">
              A new firm, built on integrity
            </div>
          </div>
        </div>

        {/* Text side */}
        <div ref={right.ref} className={`${right.className} lg:col-span-6`}>
          <div className="flex items-center gap-3 mb-6">
            <span className="gold-rule" />
            <span className="text-xs tracking-[0.28em] uppercase text-gold-500 font-bold">
              About the Firm
            </span>
          </div>

          <h2 className="font-serif text-4xl sm:text-5xl text-navy-800 tracking-tight leading-[1.1]">
            A new firm. An old-school commitment to quality.
          </h2>

          <p className="mt-6 text-base sm:text-lg text-navy-700/80 leading-relaxed">
            S.K. Infrastructure was founded in 2026 as a modern civil-works
            enterprise, registered to partner with government departments —
            including Indian Railways, PWD, Municipal Corporations and
            Panchayati Raj bodies — for public infrastructure projects.
          </p>

          <p className="mt-4 text-base sm:text-lg text-navy-700/80 leading-relaxed">
            As a new company, we do not yet carry a portfolio of past works —
            what we bring instead is a fresh, disciplined team, contemporary
            engineering practices, and a promise to earn every rupee of public
            trust placed in us.
          </p>

          <ul className="mt-8 grid sm:grid-cols-2 gap-4">
            {POINTS.map((p) => (
              <li key={p} className="flex items-start gap-3 text-sm text-navy-800">
                <CheckCircle2 className="w-5 h-5 text-gold-500 shrink-0 mt-0.5" />
                <span>{p}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default About;
